import { UilBookReader } from '@iconscout/react-unicons';
import {
  AppBar,
  Notification,
  Toolbar,
} from '@xbotvn/mui';
import axios from 'axios';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import Waiting from '../../../components/Waiting';
import { BACKEND_URL } from '../../../libs/config';
import { CHILDRENBOOK } from '../../../redux/actions/constants';
import Children from '../../Children';

const PublicChildrenBook = () => {
  const dispatch = useDispatch();
  const { unitId } = useParams();

  const [waiting, setWaiting] = useState(false);

  const updateChildrenBook = useCallback((data) => dispatch({
    type: CHILDRENBOOK.update,
    data,
    merge: false,
  }), [dispatch]);

  const fetchData = async () => {
    try {
      setWaiting(true);
      const response = await axios.post(`${BACKEND_URL}/api/childrenBook/getPublicBook`, {
        data: {
          unitId,
          isPublic: true,
        },
      });
      updateChildrenBook(_.keyBy(response.data.records, '_id'));
    } catch (error) {
      console.log(error);
      Notification.error('Thông báo', 'Lấy dữ liệu thất bại');
    } finally {
      setWaiting(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [unitId]);

  return (
    <div>
      {waiting && <Waiting fullscreen />}
      <AppBar
        position="static"
        sx={{
          bgcolor: 'theme.main',
          borderRadius: 0,
          border: 'none',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'stretch',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <UilBookReader />
            Sách cho trẻ
          </div>
        </Toolbar>
      </AppBar>
      <Children />
    </div>
  );
};

export default PublicChildrenBook;
